import React from "react";
import Loadable from "../../react-loadable";

const WeaReportGroup = Loadable({
  loader: () => import("./ReportGroup"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
WeaReportGroup.item = Loadable({
  loader: () => import("./item"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaReportGroup;



// WEBPACK FOOTER //
// ./ecology9/wea-report-group/index.js